import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Input } from 'antd';

import requestAPI from '../../../helpers/requestAPI';
import { setChangedBrowserDataWhenAdd } from '../../../actions';
import { toastSuccess, toastError } from '../../../utils/toastr';

const FileModalForm = ({ changeVisible, visible, directory, site_id, setChangedBrowserDataWhenAdd, filesTree }) => {
	const [ fileName, setFileName ] = useState('');

	const sendData = () => {
		let blob = new Blob([ ' ' ], { type: 'text/plain' });

		const params = {
			routeParams: {
				route: 'file'
			},
			method: 'POST',
			additionalQueryStringParams: {
				site_id,
				directory,
				filename: fileName
			},
			data: blob
		};

		const data = JSON.parse(filesTree[0].value);

		const addedFile = {
			value: JSON.stringify({
				name: fileName,
				siteName: data.siteName,
				siteId: site_id,
				isFolder: false,
				directory: directory ? directory : '/'
			}),
			label: fileName,
			showCheckbox: false
		};

		requestAPI(params)
			.then((response) => {
				if (response.data.ms === 'Ошибка') {
					toastError(response.data.error);
				} else {
					toastSuccess('File was created.', 'OK');
					setChangedBrowserDataWhenAdd(addedFile);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleSubmit = () => {
		sendData();
		setFileName('');
		changeVisible();
	};

	return (
		<Modal title="Create file" visible={visible} onOk={handleSubmit} onCancel={changeVisible}>
			<Input
				placeholder="Enter file name"
				value={fileName}
				onChange={(e) => {
					setFileName(e.target.value);
				}}
			/>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		site_id: state.selectedElement.siteId,
		directory: state.selectedElement.directory,
		filesTree: state.files.browserData
	};
};

const mapDispatchToProps = (dispatch) => ({
	setChangedBrowserDataWhenAdd: (data) => dispatch(setChangedBrowserDataWhenAdd(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(FileModalForm);
